/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Civil_Environmental_Engineering29Inputs */

const en_job_form_enum_civil_environmental_engineering29 = /** @type {(inputs: Job_Form_Enum_Civil_Environmental_Engineering29Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Civil and Environmental Engineering`)
};

const de_job_form_enum_civil_environmental_engineering29 = /** @type {(inputs: Job_Form_Enum_Civil_Environmental_Engineering29Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bauingenieurwesen und Umwelttechnik`)
};

/**
* | output |
* | --- |
* | "Civil and Environmental Engineering" |
*
* @param {Job_Form_Enum_Civil_Environmental_Engineering29Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_civil_environmental_engineering29 = /** @type {((inputs?: Job_Form_Enum_Civil_Environmental_Engineering29Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Civil_Environmental_Engineering29Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_civil_environmental_engineering29(inputs)
	return en_job_form_enum_civil_environmental_engineering29(inputs)
});
export { job_form_enum_civil_environmental_engineering29 as "job_form_enum_CIVIL_ENVIRONMENTAL_ENGINEERING" }